(function () {
    "use strict";

    angular.module('app').controller("ExternalInstallationScreeningController", ExternalInstallationScreeningController);

    ExternalInstallationScreeningController.$inject = ["controllerDecorator", "screeningService", "$scope", "$timeout", "installationScreening", "externalInstallationRequestApi",];
    function ExternalInstallationScreeningController(controllerDecorator, screeningService, $scope, $timeout, installationScreening, externalInstallationRequestApi) {

        const context = { RequestId: null };

        const vm = this;
        controllerDecorator.Decorate(vm, ["files", "dialog", "forms", "comments", "navigation"]);

        vm.InspectionResult = {
            Add: addInspectionResult,
            CanAdd: () => vm.request && vm.request.Screening.Status === 30
        };

        function addInspectionResult() {

            const defaultDate = new Date();
            defaultDate.setFullYear(defaultDate.getFullYear() + 5);

            $scope.InspectionResult = {
                IsApproved: false,
                ApprovedUntil: defaultDate
            };
        }

        $scope.ShouldConfirmDate = () => {
            if ($scope.InspectionResult?.IsApproved !== true)
                return false;

            if (!$scope.InspectionResult?.ApprovedUntil)
                return false;

            return habilCommon.dateUtils.isDateWithinMonths(new Date($scope.InspectionResult.ApprovedUntil), 6);
        };

        vm.InspectionResult.Options = {
            templateUrl: "@/installation/inspection-result.html",
            scope: $scope,
            onEscape: true,
            title: vm.getTranslation("InspectionResult_DialogTitle"),
            buttons: {
                ok: {
                    label: vm.getTranslation("Button_Confirm"),
                    className: "btn-primary",
                    callback: onSubmitInspectionResult,
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    className: "btn-default"
                }
            },
            onHidden: () => { $scope.InspectionResult = null; },
            size: "large"
        };

        function onSubmitInspectionResult() {
            if (!$scope.inspectionResultForm.$valid) {
                return false;
            }

            const model = $scope.InspectionResult;

            if ($scope.ShouldConfirmDate() && model.ConfirmApprovedUntil !== true) {
                $timeout(() => model.HasError = true);
                return false;
            }

            // Clear the default date when the inspection does not result in approval
            if (!model.IsApproved)
                model.ApprovedUntil = null;

            vm.SetLoadingState(true);
            installationScreening.RegisterInspection(
                { RequestId: vm.request.PublicId, Result: model },
                r => {
                    if (r.data.IsApproved) {
                        load();
                    }
                    else {
                        vm.request.Inspections.push(r.data);

                        vm.SetLoadingState(false);
                    }
                },
                vm.ShowError
            );
            return true;
        }

        vm.CanAccept = () => vm.request.Screening.Status === 10;
        vm.Accept = acceptScreenings;
        vm.CanSign = () => vm.request.Screening.Status === 40;
        vm.Sign = sign;
        vm.SaveRemark = vm.Api.SaveBaseRemark;

        vm.IsRemarkActive = (screening) => screening.Remark && (screening.Status == 10 || screening.Status == 30);
        vm.CanReject = () => vm.request.Screening.Status < 40 && !vm.request.Screening.Remark.IsValid && vm.request.Screening.Remark.Description !== null;
        vm.Reject = () => installationScreening.Reject({ PublicId: vm.request.PublicId }, _ => vm.Navigator.GoToDashboard(), vm.ShowError);

        activate();

        function activate() {
            // Parse url
            const parsed = vm.ParsePrettyUrl();
            context.RequestId = parsed.id;

            load();
        }

        function load() {
            externalInstallationRequestApi.get(context.RequestId)(
                response => {
                    vm.request = response;
                    vm.Comments.Initialize({ RequestId: context.RequestId, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

        }

        function acceptScreenings() {
            vm.SetLoadingState(true);
            installationScreening.Accept(
                { ScreeningIds: [vm.request.Screening.PublicId] },
                response => {
                    if (response.data)
                        load();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function sign() {
            screeningService.signInstallations({ Type: "installations", Items: [{ PublicId: vm.request.PublicId, }] })
                .then(r => authenticateBeforeSigning(r))
                .catch(vm.ShowError);
        }

        /**
        * Checks if the API call succeeded and prompts the user to authenticate themselves using their eId
        * @param {Object} result the result from an API call
        */
        function authenticateBeforeSigning(result) {
            if (!CheckResultReceived(result)) {
                vm.ShowError(result);
                return;
            }

            const options = {
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: vm.Settings.applicationPath + 'Account/ChangeFASLogin?returnurl=' + encodeURIComponent(vm.Navigator.CurrentPage)
            };
            vm.Dialog.Custom(options);
        }
    }
})();
